import React, { useEffect, useState } from "react";
import { IconButton, Badge, Menu, MenuItem, Typography } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function BellNotifications() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (!token) return;
    const fetchNotifications = async () => {
      try {
        const { data } = await axios.get('/api/notifications');
        // --- FIX: Ensure the response is an array before setting state ---
        if (Array.isArray(data)) {
            setNotifications(data);
        } else {
            console.error("API response for notifications is not an array:", data);
            setNotifications([]); // Reset to empty array on error
        }
      } catch (error) {
        console.error("Failed to fetch notifications", error);
        setNotifications([]); // Also reset to empty array on network/auth error
      }
    };
    fetchNotifications();
  }, [token]);

  // --- FIX: Ensure notifications is an array before filtering ---
  const unreadCount = Array.isArray(notifications) ? notifications.filter(n => !n.read).length : 0;
  
  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleMarkAsRead = async (id, link) => {
    try {
      await axios.patch(`/api/notifications/${id}/read`);
      setNotifications(currentNotifications =>
        Array.isArray(currentNotifications) ? currentNotifications.map(n =>
          n._id === id ? { ...n, read: true } : n
        ) : []
      );
      handleClose();
      if (link && link.startsWith("/")) {
        navigate(link);
      }
    } catch (err) {
      console.error("Failed to mark notification as read", err);
    }
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{ style: { minWidth: 300, maxHeight: 400 } }}
      >
        <Typography variant="h6" sx={{ px: 2, pt: 1 }}>Notifications</Typography>
        {(!Array.isArray(notifications) || notifications.length === 0) && (
          <MenuItem disabled>No notifications</MenuItem>
        )}
        {Array.isArray(notifications) && notifications.map(n => (
          <MenuItem
            key={String(n?._id)}
            onClick={() => handleMarkAsRead(n._id, n.link)}
            sx={{ fontWeight: n.read ? "normal" : "bold", whiteSpace: 'normal' }}
          >
            <div>
              <div>{n?.message}</div>
              <div style={{ fontSize: 12, color: "#888" }}>
                {n.date ? new Date(n.date).toLocaleString() : ""}
              </div>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
export default BellNotifications;